import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerCarHotbidReset() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()

  const carHotbidReset = () => {
    startListen({
      eventName: 'premium.CAR_HOTBID_RESET',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, auctionId } = event.context

        updateBarometerCarData(auctionId, carId, (item) => {
          return {
            ...item,
            bids: [
              {
                user_id: Infinity,
                status: Infinity,
                type: Infinity,
                amount: Infinity,
                timestamp: new Date(event.time * 1000).toISOString(),
                agent_bid: false,
                user_nickname: '',
              },
              ...item.bids,
            ],
          }
        })
      },
    })
  }

  return { carHotbidReset }
}
